import { render, staticRenderFns } from "./CourseOperatorSection.vue?vue&type=template&id=5d2e2440&"
import script from "./CourseOperatorSection.vue?vue&type=script&lang=ts&"
export * from "./CourseOperatorSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports